<template>
  <v-btn @click="exportDoc" color="primary" class="white--text ml-5">
    EXPORT

    <img
      :src="require('@/assets/image/Tra-Khrut-JPEG.jpg')"
      alt=""
      hidden
      id="imgsrc"
    />
  </v-btn>
</template>

<script>
import image64JSON from '@/assets/json/image64.json'
import {
  BorderStyle,
  Document,
  Media,
  Packer,
  Paragraph,
  AlignmentType,
  Table,
  TableCell,
  TableRow,
  TextRun,
  TabStopType,
  TabStopPosition,
  Header,
  HorizontalPositionRelativeFrom,
  HorizontalPositionAlign,
  VerticalPositionRelativeFrom,
  VerticalPositionAlign,
  Footer
} from 'docx'

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    lang: {
      type: String,
      default: 'eng'
    },
    save: {
      type: Function
    }
  },

  data() {
    return {}
  },

  computed: {},
  methods: {
    exportDoc() {
      this.save()
      if (this.data.isLoan) {
        this.exportDocLoan()
      } else if (this.lang === 'Tha') {
        this.exportDocTha()
      } else if (this.lang === 'Eng') {
        this.exportDocEng()
      }
    },
    exportDocTha() {
      const doc = new Document({
        styles: {
          paragraphStyles: [
            {
              id: 'default',
              name: 'default',
              basedOn: 'Normal',
              next: 'Normal',
              quickFormat: true,
              run: {
                font: 'TH SarabunPSK',
                size: 32
              }
            }
          ]
        }
      })

      const image64 = image64JSON.traKhrut

      const image7 = Media.addImage(
        doc,
        Uint8Array.from(atob(image64), c => c.charCodeAt(0)),
        113,
        113,
        {
          floating: {
            horizontalPosition: {
              relative: HorizontalPositionRelativeFrom.PAGE,
              align: HorizontalPositionAlign.CENTER
            },
            verticalPosition: {
              offset: 700000
            }
          }
        }
      )

      const date = new Date().toISOString().substr(0, 10)

      doc.addSection({
        footers: {
          default: new Footer({
            // The standard default footer
            children: [
              ...this.footerText(),
              new Paragraph({
                text:
                  'หมายเหตุ\t๑. หนังสือรับรองฉบับนี้ใช้ได้ไม่เกิน ๓ เดือน นับตั้งแต่วันที่ออกหนังสือนี้',
                tabStops: [
                  {
                    type: TabStopType.LEFT,
                    position: 1200
                  }
                ],

                style: 'default'
              }),
              this.footerReason()
            ]
          })
        },
        margins: {
          top: 100
        },
        children: [
          this.newLine(),
          this.newLine(),
          this.newLine(),
          new Paragraph({
            children: [image7],
            alignment: AlignmentType.CENTER
          }),
          ...this.addrParagraph(),
          new Paragraph({
            text: '\t' + this.data.paragraph,
            spacing: {
              before: 400
            },
            alignment: AlignmentType.JUSTIFIED,
            style: 'default'
          }),
          new Paragraph({
            text:
              'ให้ไว้ ณ วันที่ ' +
              this.$toThaiNumber(this.$dateFormat(date, { format: 'D' })) +
              ' เดือน ' +
              this.$dateFormat(date, { format: 'MMMM' }) +
              ' พ.ศ.' +
              this.$toThaiNumber(
                this.$dateFormat(date, { format: 'YYYY', addValue: 543 })
              ),
            spacing: {
              before: 400,
              after: 400
            },
            alignment: AlignmentType.CENTER,
            style: 'default'
          }),
          this.newLine(),
          this.newLine(),
          new Paragraph({
            text: '\t(' + this.data.exec.employeeNamePositionTha + ')',
            tabStops: [
              {
                type: TabStopType.CENTER,
                position: TabStopPosition.MAX * 0.75
              }
            ],
            style: 'default'
          }),
          new Paragraph({
            text:
              '\t' +
              this.data.exec.positionExecNameTha +
              this.data.exec.organizationExecLevel1NameTha,
            tabStops: [
              {
                type: TabStopType.CENTER,
                position: TabStopPosition.MAX * 0.75
              }
            ],
            style: 'default'
          }),
          new Paragraph({
            text: '\t' + this.data.replace,
            tabStops: [
              {
                type: TabStopType.CENTER,
                position: TabStopPosition.MAX * 0.75
              }
            ],
            style: 'default'
          })
        ]
      })

      // Used to export the file into a .docx file

      Packer.toBlob(doc).then(blob => {
        var fileURL = window.URL.createObjectURL(blob)
        var fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.download =
          this.data.name +
          ' - ' +
          this.$dateFormat(this.data.date, {
            format: 'DDMMYYYY',
            addValue: 543
          }) +
          '.docx'
        // document.body.appendChild(fileLink)

        fileLink.click()
        // console.log(blob)
      })
    },

    exportDocEng() {
      const doc = new Document({
        styles: {
          paragraphStyles: [
            {
              id: 'default',
              name: 'default',
              basedOn: 'Normal',
              next: 'Normal',
              quickFormat: true,
              run: {
                font: 'Times New Roman',
                size: 24
              }
            },
            {
              id: 'header',
              name: 'header',
              basedOn: 'Normal',
              next: 'Normal',
              quickFormat: true,
              run: {
                font: 'Times New Roman',
                size: 32,
                color: '#7F3F98'
              }
            },
            {
              id: 'header-sub',
              name: 'header-sub',
              basedOn: 'Normal',
              next: 'Normal',
              quickFormat: true,
              run: {
                font: 'TH SarabunPSK',
                size: 32,
                color: '#7F3F98'
              }
            },
            {
              id: 'footer',
              name: 'footer',
              basedOn: 'Normal',
              next: 'Normal',
              quickFormat: true,
              run: {
                font: 'Times New Roman',
                size: 17,
                color: '#7F3F98'
              }
            }
          ]
        }
      })

      const date = new Date().toISOString().substr(0, 10)

      const image7 = Media.addImage(
        doc,
        Uint8Array.from(atob(image64JSON.logoCmu), c => c.charCodeAt(0)),
        75,
        75,
        {
          floating: {
            horizontalPosition: {
              offset: 950000
            },
            verticalPosition: {
              offset: 480000
            }
          }
        }
      )

      const image8 = Media.addImage(
        doc,
        Uint8Array.from(atob(image64JSON.logoWater), c => c.charCodeAt(0)),
        200,
        245,
        {
          floating: {
            horizontalPosition: {
              relative: HorizontalPositionRelativeFrom.PAGE,
              align: HorizontalPositionAlign.CENTER
            },
            verticalPosition: {
              relative: VerticalPositionRelativeFrom.PAGE,
              align: VerticalPositionAlign.CENTER
            }
          }
        }
      )

      doc.addSection({
        headers: {
          default: new Header({
            // The standard default header image7

            children: [
              new Paragraph({
                children: [image7]
              }),

              new Paragraph({
                text: `\t${this.data.headerEng.eng}, Chiang Mai University`,
                style: 'header',
                tabStops: [
                  {
                    type: TabStopType.LEFT,
                    position: 1450
                  }
                ]
              }),
              new Paragraph({
                text: `\t${this.data.headerEng.tha} มหาวิทยาลัยเชียงใหม่`,
                style: 'header-sub',
                tabStops: [
                  {
                    type: TabStopType.LEFT,
                    position: 1450
                  }
                ]
              })
            ]
          })
        },
        footers: {
          default: new Footer({
            // The standard default footer
            children: [
              new Paragraph({
                text: '',
                style: 'default',
                border: {
                  bottom: {
                    color: '#7F3F98',
                    space: 1,
                    value: 'single',
                    size: 8
                  }
                },
                spacing: {
                  after: 100
                }
              }),
              new Table({
                rows: [
                  new TableRow({
                    children: [
                      new TableCell({
                        borders: {
                          top: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: '000000'
                          },
                          bottom: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: '000000'
                          },
                          left: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: '000000'
                          },
                          right: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: '000000'
                          }
                        },
                        children: [
                          new Paragraph({
                            text: this.data.footerEng.contactAddressEng,
                            style: 'footer'
                          })
                        ]
                      }),
                      new TableCell({
                        borders: {
                          top: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: '000000'
                          },
                          bottom: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: '000000'
                          },
                          left: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: '000000'
                          },
                          right: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: '000000'
                          }
                        },
                        children: [
                          new Paragraph({
                            text: this.data.footerEng.contactEmailEng,
                            style: 'footer'
                          })
                        ]
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        borders: {
                          top: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: '000000'
                          },
                          bottom: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: '000000'
                          },
                          left: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: '000000'
                          },
                          right: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: '000000'
                          }
                        },
                        children: [
                          new Paragraph({
                            text: this.data.footerEng.phoneNumberEng,
                            style: 'footer'
                          })
                        ]
                      }),
                      new TableCell({
                        borders: {
                          top: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: '000000'
                          },
                          bottom: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: '000000'
                          },
                          left: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: '000000'
                          },
                          right: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: '000000'
                          }
                        },
                        children: [
                          new Paragraph({
                            text: this.data.footerEng.webSiteLink,
                            style: 'footer'
                          })
                        ]
                      })
                    ]
                  })
                ]
              })
            ]
            // children: [
            //   new Paragraph({
            //     text: '',
            //     style: 'default',
            //     border: {
            //       bottom: {
            //         color: '#7F3F98',
            //         space: 1,
            //         value: 'single',
            //         size: 8
            //       }
            //     },
            //     spacing: {
            //       after: 100
            //     }
            //   }),
            //   new Paragraph({
            //     text: `${this.data.footerEng.contactAddressEng}\t${this.data.footerEng.contactEmailEng}`,
            //     style: 'footer',
            //     tabStops: [
            //       {
            //         type: TabStopType.LEFT,
            //         position: TabStopPosition.MAX * 0.6
            //       }
            //     ]
            //   }),
            //   new Paragraph({
            //     text: `${this.data.footerEng.phoneNumberEng}`,
            //     style: 'footer',
            //     tabStops: [
            //       {
            //         type: TabStopType.LEFT,
            //         position: TabStopPosition.MAX * 0.6
            //       }
            //     ]
            //   })
            // ]
          })
        },
        margins: {
          top: 100
        },
        children: [
          new Paragraph({
            children: [image8]
          }),
          this.newLine(),
          this.newLine(),
          new Paragraph({
            text: 'Ref: No. ' + this.data.number,
            style: 'default'
          }),
          this.newLine(),
          this.newLine(),
          new Paragraph({
            text:
              this.$dateFormat(date, { format: 'MMMM', locale: 'Eng' }) +
              ' ' +
              this.$dateFormat(date, { format: 'D', locale: 'Eng' }) +
              ' ,' +
              this.$dateFormat(date, { format: 'YYYY', locale: 'Eng' }),
            style: 'default'
          }),
          this.newLine(),
          this.newLine(),
          new Paragraph({
            text: 'To Whom It May Concern:',
            style: 'default'
          }),
          this.newLine(),
          this.newLine(),
          new Paragraph({
            text: this.data.paragraph,
            alignment: AlignmentType.JUSTIFIED,
            style: 'default'
          }),
          this.newLine(),
          this.newLine(),
          new Paragraph({
            text: this.data.exec.employeeNamePositionEng,
            style: 'default'
          }),
          new Paragraph({
            text:
              this.data.exec.positionExecNameEng +
              ' ' +
              this.data.exec.organizationExecLevel1NameEng,
            style: 'default'
          }),
          new Paragraph({
            text: this.data.replace,
            style: 'default'
          })
        ]
      })

      // Used to export the file into a .docx file

      Packer.toBlob(doc).then(blob => {
        var fileURL = window.URL.createObjectURL(blob)
        var fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.download =
          this.data.name +
          ' - ' +
          this.$dateFormat(this.data.date, {
            format: 'DDMMYYYY',
            addValue: 543
          }) +
          '.doc'
        // document.body.appendChild(fileLink)

        fileLink.click()
        // console.log(blob)
      })
    },

    exportDocLoan() {
      const doc = new Document({
        styles: {
          paragraphStyles: [
            {
              id: 'default',
              name: 'default',
              basedOn: 'Normal',
              next: 'Normal',
              quickFormat: true,
              run: {
                font: 'TH SarabunPSK',
                size: 32
              }
            }
          ]
        }
      })

      const image64 = image64JSON.traKhrut

      const image7 = Media.addImage(
        doc,
        Uint8Array.from(atob(image64), c => c.charCodeAt(0)),
        125,
        125
      )

      const date = new Date().toISOString().substr(0, 10)

      doc.addSection({
        footers: {
          default: new Footer({
            // The standard default footer
            children: [
              ...this.footerText(),
              new Paragraph({
                text:
                  'หมายเหตุ\t๑. หนังสือรับรองฉบับนี้ใช้ได้ไม่เกิน ๓ เดือน นับตั้งแต่วันที่ออกหนังสือนี้',
                tabStops: [
                  {
                    type: TabStopType.LEFT,
                    position: 1200
                  }
                ],

                style: 'default'
              }),
              this.footerReason()
            ]
          })
        },
        margins: {
          top: 100
        },
        children: [
          new Paragraph({
            children: [image7],
            alignment: AlignmentType.CENTER
          }),
          ...this.addrParagraph(),
          this.newLine(),
          new Paragraph({
            text:
              '\t' +
              this.$dateFormat(date, { format: 'MMMM' }) +
              ' ' +
              this.$dateFormat(date, { format: 'YYYY', addValue: 543 }),
            tabStops: [
              {
                type: TabStopType.LEFT,
                position: TabStopPosition.MAX * 0.5
              }
            ],
            spacing: {
              line: 300
            },
            style: 'default'
          }),
          ...this.headerLoan(),
          new Paragraph({
            text: this.data.paragraph,
            indent: {
              firstLine: 1200
            },
            alignment: AlignmentType.JUSTIFIED,
            style: 'default'
          }),
          ...this.additionalLoan(),
          new Paragraph({
            text: '\tขอแสดงความนับถือ',
            tabStops: [
              {
                type: TabStopType.CENTER,
                position: TabStopPosition.MAX * 0.75
              }
            ],
            spacing: {
              before: 400,
              after: 400
            },
            style: 'default'
          }),
          new Paragraph({
            text: '\t(' + this.data.exec.employeeNamePositionTha + ')',
            tabStops: [
              {
                type: TabStopType.CENTER,
                position: TabStopPosition.MAX * 0.75
              }
            ],
            style: 'default'
          }),
          new Paragraph({
            text:
              '\t' +
              this.data.exec.positionExecNameTha +
              this.data.exec.organizationExecLevel1NameTha,
            tabStops: [
              {
                type: TabStopType.CENTER,
                position: TabStopPosition.MAX * 0.75
              }
            ],
            style: 'default'
          }),
          new Paragraph({
            text: '\t' + this.data.replace,
            tabStops: [
              {
                type: TabStopType.CENTER,
                position: TabStopPosition.MAX * 0.75
              }
            ],
            style: 'default'
          })
        ]
      })

      // Used to export the file into a .docx file

      Packer.toBlob(doc).then(blob => {
        var fileURL = window.URL.createObjectURL(blob)
        var fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.download =
          this.data.name +
          ' - ' +
          this.$dateFormat(this.data.date, {
            format: 'DDMMYYYY',
            addValue: 543
          }) +
          '.docx'
        // document.body.appendChild(fileLink)

        fileLink.click()
        // console.log(blob)
      })
    },

    newLine() {
      return new Paragraph({
        text: '',
        style: 'default'
      })
    },

    footerText() {
      let temp = []
      this.data.footer.forEach(text_t => {
        temp.push(
          new Paragraph({
            text: text_t,
            style: 'default'
          })
        )
      })
      return temp
    },

    additionalLoan() {
      let temp = []
      this.data.additionalParagraph.forEach(text_t => {
        temp.push(
          new Paragraph({
            text: text_t,
            spacing: {
              before: 100
            },
            indent: {
              firstLine: 1200
            },
            alignment: AlignmentType.JUSTIFIED,
            style: 'default'
          })
        )
      })
      return temp
    },

    headerLoan() {
      if (this.data.reqFromReasonId === 5) {
        return [
          new Paragraph({
            text:
              'เรื่อง ขอส่งรายชื่อผู้ขอกู้เงินโครงการสินเชื่อสวัสดิการสำหรับบุคลากรภาครัฐ ในสังกัดมหาวิทยาลัยเชียงใหม่',
            spacing: {
              line: 300
            },
            style: 'default'
          }),
          new Paragraph({
            text: 'เรียน กรรมการผู้จัดการธนาคารกรุงไทย',
            spacing: {
              line: 300
            },
            style: 'default'
          }),
          new Paragraph({
            text:
              'อ้างถึง ข้อตกลงระหว่างธนาคารกรุงไทยกับมหาวิทยาลัยเชียงใหม่ ฉบับลงวันที่ ๑๕ กันยายน ๒๕๖๓',
            spacing: {
              before: 0
            },
            style: 'default'
          })
        ]
      } else if (this.data.reqFromReasonId === 4) {
        return [
          new Paragraph({
            text:
              'เรื่อง การกู้เงินโครงการสวัสดิการเงินกู้เพื่อที่อยู่อาศัย(สวัสดิการไม่มีเงินฝาก)',
            spacing: {
              line: 300
            },
            style: 'default'
          }),
          new Paragraph({
            text: 'เรียน กรรมการผู้จัดการธนาคารอาคารสงเคราะห์',
            spacing: {
              line: 300
            },
            style: 'default'
          }),
          new Paragraph({
            text:
              'อ้างถึง ข้อตกลงระหว่างธนาคารอาคารสงเคราะห์กับมหาวิทยาลัยเชียงใหม่',
            spacing: {
              before: 0
            },
            style: 'default'
          }),
          new Paragraph({
            text:
              '\tฉบับลงวันที่ ๑๕ กุมภาพันธ์ ๒๕๖๓ (รหัสสวัสดิการ ๐๐๓W๕๓๐๐๒๓)',
            spacing: {
              after: 150
            },
            style: 'default'
          })
        ]
      }
    },
    footerReason() {
      if (this.data.reqFromReasonId === 1 || this.data.reqFromReasonId === 2) {
        return new Paragraph({
          text:
            '\t๒. หนังสือฉบับนี้ใช้สำหรับ ' + this.data.reason + ' เท่านั้น',
          tabStops: [
            {
              type: TabStopType.LEFT,
              position: 1200
            }
          ],
          style: 'default'
        })
      } else {
        return new Paragraph({
          text: ''
        })
      }
    },
    addrParagraph() {
      let temp = [
        new Paragraph({
          children: [
            new TextRun('ที่ อว ' + this.data.number),
            new TextRun('\t' + this.data.addrHead[0])
          ],
          tabStops: [
            {
              type: TabStopType.LEFT,
              position: TabStopPosition.MAX * 0.65
            }
          ],
          style: 'default'
        })
      ]
      this.data.addrHead.slice(1).forEach(text_t => {
        temp.push(
          new Paragraph({
            text: '\t' + text_t,
            tabStops: [
              {
                type: TabStopType.LEFT,
                position: TabStopPosition.MAX * 0.65
              }
            ],
            style: 'default'
          })
        )
      })
      this.data.addr.forEach(text_t => {
        temp.push(
          new Paragraph({
            text: '\t' + text_t,
            tabStops: [
              {
                type: TabStopType.LEFT,
                position: TabStopPosition.MAX * 0.65
              }
            ],
            style: 'default'
          })
        )
      })
      return temp
    }
  }
}
</script>
